// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__eHTng","dot":"Loader_dot__75EnN","bounce":"Loader_bounce__9lwLe"};